export default __webpack_public_path__ + "static/hikyccase1-04e286a013f1024f3f09426bb4b43d0a.png";